export default {
    other_property: {
        name: "Other Property",
        url: "nwcg_property/other_property",
    },
    pump: {
        name: "Pump",
        url: "nwcg_property/pump",
    },
    water_tank: {
        name: "Water Tank",
        url: "nwcg_property/water_tank",
    },
}
